<template>
  <div class="realTime">
    <div class="left">
      <div class="top">
        <div class="top-header">
          <el-select class="top-select" filterable v-model="elevatorId" placeholder="请选择"
            @change="(id) => selectElevator(id, true)">
            <el-option v-for="item in elevatorList" :key="item.id" :label="item.remark" :value="item.id">
            </el-option>
          </el-select>
          <!-- <div class="top-right" v-if="elevatorType == 'elevator'">
            <span class="right-line"></span>
            <div class="right-textCon">
              <span class="right-text1">运行里程</span>
              <span class="right-text2">{{ distanceFormatter }}</span>
            </div>
          </div> -->
        </div>
        <div class="top-content">
          <div style="position: relative;height: 100%;display: flex;align-items: flex-end;">
            <img v-show="elevatorType == 'elevator'" style="margin-bottom: 0px;  width: 100%;
          height: 100%;" :src="require(`@/assets/elevator.png`)" alt="" />

            <img v-show="elevatorType == 'escalator'" style="margin-bottom: 0px;  width: 100%;
          height: 78%;" :src="require(`@/assets/elevator2.png`)" alt="" />
            <img v-show="elevatorType == 'eMachinery'" style="margin-bottom: 0px;  width: 100%;
          height:74%;" :src="require(`@/assets/eMachinery.png`)" alt="" />
            <img v-show="elevatorType == 'eWaterPump'" style="margin-bottom: 0px;      width: 100%;
    height: 70%;" :src="require(`@/assets/eWaterPump.png`)" alt="" />
            <img v-show="elevatorType == 'FanMotor'" style="margin-bottom: 0px;  width: 100%;
          height: 83%;" :src="require(`@/assets/FanMotor.png`)" alt="" />
            <el-tooltip v-for="item in pointList" :key="item.position" effect="dark" :content="item.position"
              placement="top">
              <img v-if="item.coord" class="pointImg" :style="`top:${item.coord[1]}px;left:${item.coord[0]}px`"
                :src="getImageSource(item.status)" alt="" />
            </el-tooltip>
          </div>
          <div v-for="item, index in sensorList" :class="`${item.type}_status_${index + 1} status_common`">
            <div>
              <span class="line_1"></span>
              <span class="line_2"></span>
            </div>
            <div class="textCon">
              <span class="text_1">{{ item.position }}</span>
              <span
                :style="item.status == 1 ? 'color:#44D7B6' : (item.status == 2 ? 'color:#F33D3D' : (item.status == 3 ? 'color:rgb(247, 181, 0)' : ''))"
                class="text_2">{{ item.status == 1 ? '正常' : (item.status == 2 ? '告警' : (item.status ==
                  3 ? '预警' : '离线')) }}</span>
            </div>
          </div>
          <!-- <div class="status_1 status_common">
            <div>
              <span class="line_1"></span>
              <span class="line_2"></span>
            </div>
            <div class="textCon">
              <span class="text_1">制动器状态</span>
              <span class="text_2">{{ brakingFormatter }}</span>
            </div>
          </div>
          <div class="status_3 status_common">
            <div>
              <span class="line_1"></span>
              <span class="line_2"></span>
            </div>
            <div class="textCon">
              <span class="text_1">拽引机状态</span>
              <span class="text_2">{{ tractorFormatter }}</span>
            </div>
          </div>
          <div class="status_2 status_common" v-if="elevatorType == 'elevator'">
            <div>
              <span class="line_1"></span>
              <span class="line_2"></span>
            </div>
            <div class="textCon">
              <span class="text_1">轿厢状态</span>
              <span class="text_2">{{ carFormatter }}</span>
            </div>
          </div> -->
          <!-- <div class="status_b1 status_common" v-if="elevatorType == 'elevator'">
            <div>
              <span class="line_1"></span>
              <span class="line_2"></span>
            </div>
            <div class="textCon">
              <span class="text_1">运行速度</span>
              <span class="text_2">{{ speedFormatter }}</span>
            </div>
          </div>
          <div class="status_b2 status_common" v-if="elevatorType == 'elevator'">
            <div>
              <span class="line_1"></span>
              <span class="line_2"></span>
            </div>
            <div class="textCon">
              <span class="text_1">倾角</span>
              <span class="text_2">{{ angleFormatter }}</span>
            </div>
          </div>
          <div class="status_b3 status_common" v-if="elevatorType == 'elevator'">
            <div>
              <span class="line_1"></span>
              <span class="line_2"></span>
            </div>
            <div class="textCon">
              <span class="text_1">当前楼层</span>
              <span class="text_2">{{ floorFormatter }}</span>
            </div>
          </div> -->
        </div>
        <!-- <escalatorList ref="escalatorList" v-else @selectGZ="selectGZ"></escalatorList> -->
      </div>
      <div class="bottom">
        <div class="bottom-top">
          <div>
            <img src="../../../assets/square-point.png" alt="" />
            <span @click="clickBtn(2)" :class="flag == 2 ? 'bottom-t1' : 'bottom-t2'">设备列表</span>
            <span class="bottom-t2">/</span>
            <span @click="clickBtn(1)" :class="flag == 1 ? 'bottom-t1' : 'bottom-t2'">预警信息</span>
          </div>
          <span v-if="flag == 1" @click="toWarnSearch" class="bottom-t3">···</span>
        </div>

        <el-table v-if="flag == 2" size="mini" ref="sensorTable" :data="sensorList.filter(item => item.usbPort != 106)"
          class="Table" :highlight-current-row="true" :show-header="false" :row-style="{
            fontSize: '12px',
            color: '#7F8488',
            height: '34px',
          }">
          <el-table-column header-align="center" align="center" prop="elevatorName" label="设备名">
          </el-table-column>
          <el-table-column header-align="center" align="center" prop="position" label="部件名">
          </el-table-column>
          <el-table-column header-align="center" align="center" label="状态">
            <template slot-scope="scope">
              <span
                :style="scope.row.status == 1 ? 'color:#44D7B6' : (scope.row.status == 2 ? 'color:#F33D3D' : (scope.row.status == 3 ? 'color:rgb(247, 181, 0)' : ''))">{{
                  scope.row.status == 1 ? '正常' : (scope.row.status == 2 ? '告警' : (scope.row.status == 3 ? '预警' : '离线'))
                }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-table v-else size="mini" ref="warningTable" :data="warningList.filter(item => item.usbPort != 106)"
          class="Table" :highlight-current-row="true" @row-click="selectAudio" :row-class-name="tableRowClassName"
          :show-header="false" :row-style="{
            fontSize: '12px',
            color: '#7F8488',
            height: '34px',
          }">
          <el-table-column header-align="center" align="center" prop="elevatorName" label="设备名">
          </el-table-column>
          <el-table-column header-align="center" align="center" prop="position" label="预警位置">
          </el-table-column>
          <el-table-column header-align="center" align="center" prop="yysyResult" label="故障类别" :formatter="yysyFormatter">
            <template slot-scope="scope">
              <div style="display: flex;    align-items: center;">
                <img 
                 :src="require(scope.row.level == 3 ? '@/assets/yellowIcon.png':'@/assets/redIcon.png')"
                alt="" />
              <span>{{ yysyFormatter(scope.row) }}</span>
              </div>
              
            </template>
          
          </el-table-column>
          <el-table-column header-align="center" align="center" prop="warningTime" label="预警时间"
            :formatter="timeFormatter">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="right">
      <Audio v-if="flag == 1" ref="Audio" @selectAudio="selectAudio" :getWarningList="getWarningList"></Audio>
      <Equipment v-else ref="Equipment"></Equipment>
    </div>

    <tipsDialog ref="tipsDialog"></tipsDialog>
    <warnTips ref="warnTips"></warnTips>

  </div>
</template>
  
<script>
import Audio from "./audio.vue";
import Equipment from "./equipment.vue";
import escalatorList from './escalator-list.vue';
import tipsDialog from '@/components/tipsDialog.vue';
import warnTips from './warnTips.vue';
import { log } from "three";

export default {
  components: {
    Audio,
    Equipment,
    escalatorList,
    tipsDialog,
    warnTips
  },
  data() {
    return {
      timer: null, //图表定时器
      elevatorSite: '',
      elevatorType: '',
      elevatorId: '',
      elevatorName: '',
      elevatorList: [],
      flag: 2, //1是预警列表，2是设备列表,
      warningList: [],
      sensorList: [],
      pointList: [], //传感器对应的图片中点的列表
      index: 0,
    };
  },
  mounted() {
    this.getElevatorList();
  },
  beforeDestroy() {
    this.clearTimer()
  },
  deactivated() {
    this.clearTimer()
    this.$store.state.curAudioData = null
  },
  activated() {
    if (!this.$route.query.id) {
      return
    }

    if (!this.$store.state.curAudioData) {
      this.flag = 2
    }

    //从site跳转到此页面后的操作
    setTimeout(() => {
      if (this.$route.query.id && this.elevatorList.length != 0) {
        //设备跳转
        this.elevatorId = Number(this.$route.query.id)
        this.selectElevator(this.elevatorId)

        if (!this.$store.state.curAudioData) {
          return
        }

        //异常跳转
        //等待加载异常列表
        setTimeout(() => {
          this.clickBtn(1)
          //选择音频
          this.$nextTick(() => {
            if (this.$store.state.curAudioData) {
              setTimeout(() => {
                this.selectAudio(this.$store.state.curAudioData)
              }, 200)
            }
          })
        }, 400)
      }
    }, 600)
  },
  computed: {
    floorFormatter() {
      const realTimeData = this.$store.state.realTimeData;
      if (realTimeData) {
        if (realTimeData.floor < 0) {
          return realTimeData.floor + '/楼';
        } else if (realTimeData.floor >= 0) {
          return realTimeData.floor + 1 + '/楼';
        }
        return "——";
      }
    },
    distanceFormatter() {
      const realTimeData = this.$store.state.realTimeData;
      if (realTimeData) {
        if (realTimeData.distance === -1) {
          return "——";
        } else {
          return (realTimeData.distance / 1000).toFixed(2) + " km";
        }
      }
    },
    angleFormatter() {
      const realTimeData = this.$store.state.realTimeData;
      let angleX = "";
      let angleY = "";
      if (realTimeData) {
        realTimeData.angleX == "null"
          ? (angleX = "——")
          : (angleX = "x" + (realTimeData.angleX / 10).toFixed(2));

        realTimeData.angleY == "null"
          ? (angleY = "——")
          : (angleY = "y" + (realTimeData.angleY / 10).toFixed(2));

        return angleX + " " + angleY;
      }
      return "--";
    },
    carFormatter() {
      const realTimeData = this.$store.state.realTimeData;

      if (realTimeData) {
        if (realTimeData.car == -1) {
          return "——";
        }

        return "正常";
      }
    },
    brakingFormatter() {
      const realTimeData = this.$store.state.realTimeData;
      if (realTimeData) {
        if (realTimeData.speed == -1) {
          return "——";
        }

        return "正常";
      }
    },
    tractorFormatter() {
      const realTimeData = this.$store.state.realTimeData;
      if (realTimeData) {
        if (realTimeData.speed == -1) {
          return "——";
        }

        return "正常";
      }
    },
    speedFormatter() {
      const realTimeData = this.$store.state.realTimeData;
      if (realTimeData) {
        if (realTimeData.speed === -1) {
          return "——";
        } else {
          return (realTimeData.speed / 100).toFixed(2) + "m/s";
        }
      }
    },
  },
  methods: {
    clearTimer() {
      clearInterval(this.timer);
      this.timer = null;
    },
    clickBtn(flag) {
      console.log(flag, this.warningList);
      if (flag == 1 && this.warningList.length == 0) {
        this.$refs.tipsDialog.visible = true
        return
      }
      this.flag = flag

      if (this.flag == 1) {
        this.clearTimer()
        if (!this.$store.state.curAudioData) {
          this.getWarningList();
        }
      } else if (this.flag == 2) {
        this.$store.state.curAudioData = null
        this.getSensorListList()
      }
    },
    getImageSource(status) {
      if (status === 3) {
        return require('@/assets/pwarning.svg');
      } else if (status === 2) {
        return require('@/assets/palarm.svg');
      } else {
        return require('@/assets/pnormal.svg');
      }
    },
    getCoord1(position) {
      //直梯
      switch (position) {
        case '制动1':
          return [130, 45]
        case '制动2':
          return [180, 30]
        case '制动A':
          return [130, 45]
        case '制动B':
          return [180, 30]
        case '电机':
          return [220, 50]
        case '轿厢':
          return [195, 190]
        case '轿厢门':
          return [195, 190]
          
      }
    },
    getCoord2(position) {
      //扶梯
      switch (position) {
      
        case '电机':
          return [435, 230]


        case '减速箱':
          return [435, 290]


        case '抱闸A':
          return [410, 260]
        case '制动A':
          return [410, 260]

        case '抱闸B':
          return [455, 260]
        case '制动B':
          return [455, 260]


        case '上-扶手换向轮':
          return [335, 230]
        case '左扶手驱动轮':
          return [335, 230]

        case '上-托辊组':
          return [255, 240]
        case '上-左梳齿板':
          return [255, 240]

        case '上-卸载轨A':
          return [335, 310]
        case '左扶手带压带轮':
          return [335, 310]

        case '上-链轮轴承':
          return [370, 240]
        case '上-右链轮轴承':
          return [370, 240]

        case '下-链轮轴承':
          return [180, 430]
        case '左链轮轴承':
          return [180, 430]

        case '下-右扶手轮B':
          return [110, 355]
        case '下-右链轮轴承':
          return [110, 355]

        case '下-左扶手轮A':
          return [80, 355]
        case '左转向轮轴承':
          return [80, 355]

        case '下-梳齿板':
          return [120, 400]
        case '下-左梳齿板':
          return [120, 400]
      }
    },
    getCoord3(position) {
      
      //电机
      switch (position) {
        case '电机':
          return [255, 360]
      }
    },
    getCoord4(position) {
      //电机
      switch (position) {
      case '电机自由端':
          return [100, 210]
          case '电机驱动端':
          return [175, 240]
          case '联轴器':
          return [245, 300]
          case '水泵轴承':
          return [355, 310]
      }
    },
    getCoord5(position) {
      //电机
      switch (position) {
        case '电机自由端':
          return [95, 225]
          case '电机驱动端':
          return [250, 230]
          case '皮带轴承':
          return [300, 290]
          case '电机底部转子':
          return [215, 365]
      }
    },
   
    toWarnSearch() {
      this.$router.push({ path: '/home/warnSearch', query: { id: this.elevatorId } })
    },
    selectGZ(id) {
      this.elevatorId = id
      if (this.flag == 2) {
        this.getSensorListList();
      } else {
        this.getWarningList();
      }
    },
    selectAudio(rowData, flag) {
      if (this.warningList.length == 0) {
        return
      }
      if (flag == 'previous' || flag == 'next') {
        if (flag == 'previous') {
          if (this.index == 0) {
            this.$message.warning('到顶了')
            return
          }
          this.index -= 1
        } else {
          if (this.index == this.warningList.length - 1) {
            this.$message.warning('到底了')
            return
          }
          this.index += 1
        }
        const data = this.warningList[this.index]
        //高亮表格
        this.$refs.warningTable.setCurrentRow(data)
        this.$refs.Audio.warningData = data
      } else {
        this.index = rowData.index
        this.$refs.Audio.warningData = rowData
        this.$refs.warningTable.setCurrentRow(this.warningList[this.index])
      }
      this.$refs.Audio.getWarningAudio()
        .then((result) => {
          if (result !== "success" && this.$refs.Audio) {
            this.$refs.Audio.clear()
            this.$refs.warnTips.visible = true
            this.$refs.warnTips.message = result
          }
        })
    },
    selectElevator(id, flag) {
      if (flag) {
        this.$store.state.curAudioData = null
      }

      this.$socket.emit("chooseElevator", id);
      this.elevatorType = this.elevatorList.find(elevator => elevator.id === id).type;
      this.elevatorSite = this.elevatorList.find(elevator => elevator.id === id).site;
      this.elevatorName = this.elevatorList.find(elevator => elevator.id === id).remark;
      // if (this.elevatorSite == '广州地铁') {
      //   this.$nextTick(() => {
      //     this.$refs.escalatorList.list = this.elevatorList.filter(item => item.site === '广州地铁');
      //     this.$refs.escalatorList.selectedId = id
      //   })
      // }

      this.getSensorListList();
      this.getWarningList();
    },
    timeFormatter(row, col, cell) {
      return row.warningTime.substring(5);
    },
    yysyFormatter(row, col, cell) {
      if (row.yysyResult) {
        return row.yysyResult.split("-")[0];
      }
      return '无识别结果';
    },
    getElevatorList() {
      this.$api.elevator.list().then((res) => {
        if (res.success) {
          this.elevatorList = res.data;
          if (this.elevatorList.length > 0) {
            this.elevatorId = this.elevatorList[0].id;
            this.elevatorType = this.elevatorList[0].type;
            this.elevatorSite = this.elevatorList[0].site
            this.elevatorName = this.elevatorList[0].remark
            // if (this.elevatorSite == '广州地铁') {
            //   this.$nextTick(() => {
            //     this.$refs.escalatorList.list = this.elevatorList.filter(item => item.site === '广州地铁');
            //     this.$refs.escalatorList.selectedId = this.elevatorId
            //   })
            // }
            this.$socket.emit("chooseElevator", this.elevatorId);
            if (!this.$store.state.curAudioData) {
              this.getSensorListList();
              this.getWarningList();
            }
          }
        }
      });
    },
    getSensorListList() {
      //给传感器列表加上当前电梯的类型
      const type = this.elevatorList.find((item) => {
        return item.id == this.elevatorId
      }).type
      console.log(type);
      const params = {
        elevatorId: this.elevatorId,
      }
      this.$api.sensor.list(params).then((res) => {
        if (res.success) {
          this.sensorList = res.data.filter(item => item.usbPort != 106);
          this.sensorList.forEach((item) => {
            item.type = type
          })
          let curMovementSensor = ''
          let curVibrationSensorList = []
          //这个是位置信息
          let curEscalatorSensorList = []
          //这个才是sensoreID信息
          let curEscalatorSensorList2 = []

          //处理图片对应的点列表
          this.pointList = this.sensorList.map((item) => {
            return {
              position: item.position,
              status: item.status,
              coord: this.elevatorType == 'elevator' ?
                this.getCoord1(item.position) :this.elevatorType == 'escalator' ?
                this.getCoord2(item.position) :
                this.elevatorType == 'eMachinery' ?
                this.getCoord3(item.position) :
                this.elevatorType == 'eWaterPump' ?
                this.getCoord4(item.position) :
                this.elevatorType == 'FanMotor' ?
                this.getCoord5(item.position) : this.getCoord2(item.position)
            }
          })

          if (this.$store.state.curAudioData) {
            return
          }
          //扶梯处理
          if (this.elevatorType == 'escalator') {
            curEscalatorSensorList = this.sensorList.map(item => {
              return { position: item.position, location: item.location }
            })
            curEscalatorSensorList.push({ position: '上半区' })
            curEscalatorSensorList.push({ position: '下半区' })

            this.sensorList.forEach(item => {
              if (item.sensorType === 1 || item.sensorType === 8) {
                curEscalatorSensorList2.push(item.sensorId);
              }
            })
          }
          //直梯处理
          else {
            this.sensorList.forEach(item => {
              if (item.sensorType === 1 || item.sensorType === 8) {
                curVibrationSensorList.push(item.sensorId);
              } else if (item.sensorType === 2) {
                curMovementSensor = item.edgeCode + "_" + item.usbPort;
              }
            })
          }

          if (!this.$refs.Equipment) {
            return
          }
          this.$refs.Equipment.elevatorId = this.elevatorId
          this.$refs.Equipment.elevatorType = this.elevatorType
          this.$refs.Equipment.elevatorName = this.elevatorName
          this.$refs.Equipment.curMovementSensor = curMovementSensor
          this.$refs.Equipment.elevatorIdInfo = this.elevatorList.find(elevator => elevator.id === this.elevatorId)
          this.$store.state.curVibrationSensorList = curVibrationSensorList
          this.$store.state.curEscalatorSensorList = curEscalatorSensorList
          this.$store.state.curEscalatorSensorList2 = curEscalatorSensorList2
          //定时刷新全部图表;
          //先执行一次
          this.clearTimer()
          this.$refs.Equipment.getSensorHistoryTimerTask();
          this.timer = setInterval(() => {
            this.$refs.Equipment.getSensorHistoryTimerTask();
          }, 10000);
        }
      });
    },
    async getWarningList() {
      const params = {
        pageNo: 1,
        pageSize: 999,
        elevatorId: this.elevatorId,
      };
      this.$api.warning.page(params).then((res) => {
        if (res.success) {
          this.warningList = res.data.records.filter((item) => {
            return item.status == 1 && item.usbPort != 106
          });

          if (this.flag === 2) {
            return
          }

          if (this.warningList.length > 0) {
            if (!this.$store.state.curAudioData) {
              //高亮表格
              //和跳转高亮冲突
              this.index = 0
              this.$refs.warningTable.setCurrentRow(this.warningList)
              this.$refs.Audio.warningData = this.warningList[0]
              this.$refs.Audio.getWarningAudio().then(result => {
                if (result !== "success" && this.$refs.Audio) {
                  this.$refs.Audio.clear()
                  this.$refs.warnTips.visible = true
                  this.$refs.warnTips.message = result
                }
              });
            }
          } else {
            this.$refs.Audio.clear()
          }
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      //配置表格行的index
      row.index = rowIndex;
    },
  },
  watch: {
  },
};
</script>
  
<style lang="less" scoped>
.realTime {
  display: flex;
  width: 100%;
  height: 100%;

  /* 清除表格横线 */
  /deep/ .el-table__row>td,
  th {
    border: none !important;
  }

  .left {
    width: 494px;
    // min-width: 474px;
    margin-right: 22px;
    display: flex;
    flex-direction: column;

    .top {
      background-color: var(--cardbg-color);
      margin-bottom: 21px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      height: 566px;
      min-height: 566px;

      .top-header {
        width: calc(100% - 30px);
        display: flex;
        justify-content: space-between;
        margin: 15px 15px;

        .top-right {
          display: flex;
          align-items: center;
        }

        .right-line {
          width: 1px;
          height: 38px;
          display: block;
          background: #44D7B6;
          margin-right: 3px;
        }

        .right-textCon {
          width: 197px;
          height: 38px;
          display: flex;
          flex-direction: column;
          border: 1px solid #44D7B6;
          padding-left: 8px;
        }

        .right-text1 {
          font-size: 10px;
          color: #7F8488;
          line-height: 21px;
        }

        .right-text2 {
          font-size: 14px;
          color: #44D7B6;
        }
      }

      .top-content {
        position: relative;
        width: 100%;
        height: calc(100% - 44px);
        display: flex;
        justify-content: center;
        align-items: center;

        .pointImg {
          position: absolute;
          width: 30px;
          height: 30px;
        }

        img {}

        .status_common {
          position: absolute;
          color: white;
          display: flex;
          // width: 80px;
        }

        .elevator_status_1 {
          top: 15px;
          left: 15px;
        }

        .elevator_status_2 {
          top: 15px;
          right: 15px;
        }

        .elevator_status_3 {
          top: 70px;
          left: 15px;
        }

        .elevator_status_4 {
          top: 70px;
          right: 15px;
        }

        .elevator_status_5 {
          top: 125px;
          left: 15px;
        }

        .elevator_status_6 {
          top: 125px;
          right: 15px;
        }

        .elevator_status_7 {
          top: 180px;
          left: 15px;
        }

        .elevator_status_8 {
          top: 180px;
          right: 15px;
        }

        .status_b1 {
          bottom: 15px;
          left: 15px;
        }

        .status_b2 {
          bottom: 15px;
          right: 15px;
        }

        .status_b3 {
          bottom: 65px;
          left: 15px;
        }

        .escalator_status_1 {
          top: 15px;
          left: 15px;
        }

        .escalator_status_2 {
          top: 15px;
          left: 105px;
        }

        .escalator_status_3 {
          top: 15px;
          left: 195px;
        }

        .escalator_status_4 {
          top: 15px;
          left: 285px;
        }

        .escalator_status_5 {
          top: 15px;
          left: 375px;
        }

        .escalator_status_6 {
          top: 65px;
          left: 15px;
        }

        .escalator_status_7 {
          top: 65px;
          left: 105px;
        }

        .escalator_status_8 {
          top: 65px;
          left: 195px;
        }

        .escalator_status_9 {
          top: 65px;
          left: 285px;
        }

        .escalator_status_10 {
          top: 65px;
          left: 375px;
        }

        .escalator_status_11 {
          top: 115px;
          left: 15px;
        }

        .escalator_status_12 {
          top: 115px;
          left: 105px;
        }

        .escalator_status_13 {
          top: 115px;
          left: 195px;
        }

        .escalator_status_14 {
          top: 115px;
          left: 285px;
        }

        .escalator_status_15 {
          top: 115px;
          left: 375px;
        }

        .eMachinery_status_1 {
          top: 15px;
          left: 15px;
        }

        .eMachinery_status_2 {
          top: 15px;
          left: 105px;
        }

        .eMachinery_status_3 {
          top: 15px;
          left: 195px;
        }

        .eMachinery_status_4 {
          top: 15px;
          left: 285px;
        }

        .eMachinery_status_5 {
          top: 15px;
          left: 375px;
        }

        .eMachinery_status_6 {
          top: 65px;
          left: 15px;
        }

        .eMachinery_status_7 {
          top: 65px;
          left: 105px;
        }

        .eMachinery_status_8 {
          top: 65px;
          left: 195px;
        }

        .eMachinery_status_9 {
          top: 65px;
          left: 285px;
        }

        .eMachinery_status_10 {
          top: 65px;
          left: 375px;
        }

        .eWaterPump_status_1 {
          top: 15px;
          left: 15px;
        }

        .eWaterPump_status_2 {
          top: 15px;
          left: 105px;
        }

        .eWaterPump_status_3 {
          top: 15px;
          left: 195px;
        }

        .eWaterPump_status_4 {
          top: 15px;
          left: 285px;
        }

        .eWaterPump_status_5 {
          top: 15px;
          left: 375px;
        }

        .eWaterPump_status_6 {
          top: 65px;
          left: 15px;
        }

        .eWaterPump_status_7 {
          top: 65px;
          left: 105px;
        }

        .eWaterPump_status_8 {
          top: 65px;
          left: 195px;
        }

        .eWaterPump_status_9 {
          top: 65px;
          left: 285px;
        }

        .eWaterPump_status_10 {
          top: 65px;
          left: 375px;
        }

        .FanMotor_status_1 {
          top: 15px;
          left: 15px;
        }

        .FanMotor_status_2 {
          top: 15px;
          left: 105px;
        }

        .FanMotor_status_3 {
          top: 15px;
          left: 195px;
        }

        .FanMotor_status_4 {
          top: 15px;
          left: 285px;
        }

        .FanMotor_status_5 {
          top: 15px;
          left: 375px;
        }

        .FanMotor_status_6 {
          top: 65px;
          left: 15px;
        }

        .FanMotor_status_7 {
          top: 65px;
          left: 105px;
        }

        .FanMotor_status_8 {
          top: 65px;
          left: 195px;
        }

        .FanMotor_status_9 {
          top: 65px;
          left: 285px;
        }

        .FanMotor_status_10 {
          top: 65px;
          left: 375px;
        }

        .line_1 {
          width: 1px;
          height: 4px;
          border: 1px solid #5BB3BC;
          display: block;
          background: #5BB3BC;
          margin-bottom: 2px;
        }

        .line_2 {
          width: 1px;
          height: 29px;
          border: 1px solid #44D7B6;
          display: block;
          background: #5BB3BC;
        }

        .textCon {
          display: flex;
          flex-direction: column;
          margin-left: 6px;
          justify-content: space-between;
        }

        .text_1 {
          font-size: 12px;
          color: #7F8488;
        }

        .text_2 {
          font-size: 14px;
          color: #44D7B6;
        }
      }
    }

    .bottom {
      position: relative;
      flex: 1;
      background-color: var(--cardbg-color);

      .bottom-top {
        display: flex;
        align-items: center;
        margin: 8px 0 0 12px;
        justify-content: space-between;
      }

      .bottom-t1 {
        font-size: 16px;
        color: #44d7b6;
        font-weight: 400;
        margin-left: 8px;
        margin-bottom: 2px;
        cursor: pointer;
      }

      .bottom-t2 {
        font-size: 12px;
        color: #6d7278;
        font-weight: 400;
        margin-left: 8px;
        cursor: pointer;
      }

      .bottom-t3 {
        font-size: 24px;
        font-weight: 600;
        color: #44d7b6;
        margin-right: 15px;
        cursor: pointer;
      }
    }

    .bottom::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      border-top: 1px solid;
      border-image: linear-gradient(270deg,
          var(--borderImage),
          rgba(68, 215, 182, 1)) 1 1;
      border-image-slice: 1;
    }

    .Table {
      max-height: 250px;
      overflow: auto;
    }
  }

  .right {
    flex: 1;
    background-color: var(--cardbg-color);
  }
}
</style>
  
    


// WEBPACK FOOTER //
// src/pages/home/realTime/index.vue